import { Box } from '@chakra-ui/react'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { BaseSelect } from './Select/Select'

export const GranularitySelect = ({
  isDisabled = false,
  onChange,
  value,
  options: optionsProp = undefined,
  ml = 'auto',
  w = '156px',
  leftIcon,
}: {
  isDisabled?: boolean
  onChange: any
  value: any
  options?: { value: string; label: string; isDisabled?: boolean }[]
  ml?: string
  w?: string
  leftIcon?: ReactNode
}) => {
  const { t } = useTranslation()
  const options = optionsProp ?? [
    { value: 'quarterHour', label: t('common.quarter_hour') },
    { value: 'day', label: t('common.day') },
  ]
  return (
    <Box ml={ml} w={w}>
      <BaseSelect
        isDisabled={isDisabled}
        label=''
        fontSize='14px'
        isInvalid={false}
        name=''
        onChange={onChange}
        value={value}
        options={options}
        leftIcon={leftIcon}
      />
    </Box>
  )
}
